import {
	Textarea as StyledTextarea,
	type TextareaProps,
} from 'components/FormUi';

import { useValidatedController } from './hooks';

interface Props extends TextareaProps {
	name: string;
	requiredErrorMessage?: string;
}

export default function Textarea({
	defaultValue,
	disabled,
	name,
	required,
	requiredErrorMessage,
	...rest
}: Props) {
	const { errorMessage, invalid, onBlur, onChange, valid, value } =
		useValidatedController({
			name,
			defaultValue,
			requiredErrorMessage,
			required,
			disabled,
		});

	return (
		<StyledTextarea
			onChange={onChange}
			onBlur={onBlur}
			value={value}
			invalid={invalid}
			valid={valid}
			errorMessage={errorMessage}
			disabled={disabled}
			{...rest}
		/>
	);
}
Textarea.displayName = 'FinalForm_Textarea';
